const initParallax = () => {
    const parallaxElements = document.querySelectorAll('[data-parallax]');
    if (!parallaxElements.length) return;

    let windowHeight = window.innerHeight;
    
    window.addEventListener('resize', () => {
        windowHeight = window.innerHeight;
    }, { passive: true });

    const items = Array.from(parallaxElements).map(el => {
        return {
            el: el,
            parent: el.parentElement,
            speed: parseFloat(el.dataset.parallaxSpeed) || .15,
            direction: el.dataset.parallaxDirection === 'down' ? 1 : -1,
            currentY: 0,
            targetY: 0
        };
    });

    const updateTargets = () => {
        items.forEach(item => {
            const rect = item.parent.getBoundingClientRect();
            
            if (rect.top <= windowHeight && rect.bottom >= 0) {
                const centerOffset = (rect.top + rect.height / 2) - (windowHeight / 2);
                item.targetY = centerOffset * item.speed * item.direction;
            }
        });
    };

    const lerp = (start, end, factor) => start + (end - start) * factor;

    const render = () => {
        items.forEach(item => {
            item.currentY = lerp(item.currentY, item.targetY, .07);
            
            if (Math.abs(item.targetY - item.currentY) > .05) {
                item.el.style.transform = `translate3d(0, ${item.currentY}px, 0) scale(1)`;
            }
        });
        
        requestAnimationFrame(render);
    };

    window.addEventListener('scroll', updateTargets, { passive: true });
    
    updateTargets();
    render();
};

document.addEventListener('DOMContentLoaded', initParallax);